import React from 'react';
import SignIn from '../../general/sign-in/sign-in.component'
import SignUp from '../../general/sign-up/sign-up.component';
import './sign-in-and-sign-up.styles.scss';
import Padding from '../../../general/padding/Padding';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import ProgressIndicator from '../../general/progress-indicator/progress-indicator.component';

const SignInAndSignUp = ({firstSignText,secondSignText,heading}) => {
    
    const location = useLocation();
    const currentPath = location.pathname.substring(1,location.pathname.lastIndexOf('/'));//to get only the current path till student/faculty portal
    
    return(
        <Grid container className="sign-in-and-sign-up" spacing={20} justifyContent="center">
        <ProgressIndicator />
        <Grid item sx={{width:'100%',textAlign:'center',padding:0,margin:0}} justifyContent="center">
        <Typography variant="h3" sx={{fontFamily:'Montserrat'}}>{heading}</Typography>
        </Grid>
        <Grid item style={{padding:'4%'}}>
        <SignIn firstSignText={firstSignText} buttonLink={`${currentPath}/two`} />
        </Grid>
        <Divider orientation="vertical" flexItem/>
        <Grid item style={{padding:'4%'}}> 
        <SignUp buttonLink={`${currentPath}/two`} secondSignText={secondSignText} />
        </Grid>
        <Divider orientation="vertical" flexItem/>
        </Grid>
    )
}

export default SignInAndSignUp; 